import { sameId } from './parts';
const typeName = setup => setup.utilityTypeName || 'Other';
const byName = (a, b) => String(a).localeCompare(String(b), undefined, {
  sensitivity: 'base'
});
const byTypeThenName = (a, b) => byName(typeName(a), typeName(b)) || byName(a.name, b.name);
const ofType = (setups, typeId) => typeId ? setups.filter(setup => sameId(setup.utilityTypeId, typeId)) : setups;

/** The utility types the company's setups are for, by name: the setups list's filter, and New setup's types. */
export const setupTypes = setups => {
  const types = new Map();
  setups.forEach(setup => {
    const key = String(setup.utilityTypeId).toLowerCase();
    if (!types.has(key)) types.set(key, {
      id: setup.utilityTypeId,
      name: typeName(setup)
    });
  });
  return [...types.values()].sort((a, b) => byName(a.name, b.name));
};

/** The setups the list shows: live ones, of one type when it's picked, by type and then name. */
export const liveSetups = (setups, typeId) => ofType(setups, typeId).filter(setup => !setup.isArchived).sort(byTypeThenName);

/** Archived setups, kept apart under "Show archived". */
export const archivedSetups = (setups, typeId) => ofType(setups, typeId).filter(setup => setup.isArchived).sort(byTypeThenName);

/**
 * The setup New setup starts from for a type: its most-used live setup, or an archived one when that's all there is.
 * Null for a type the company has no setup of.
 */
export const modelSetupFor = (setups, typeId) => {
  var _sort$;
  return (_sort$ = [...ofType(setups, typeId)].sort((a, b) => Number(a.isArchived) - Number(b.isArchived) || b.utilities - a.utilities || byName(a.name, b.name))[0]) !== null && _sort$ !== void 0 ? _sort$ : null;
};

/**
 * property-service archives a setup only once no utility follows it and none is scheduled to move to it. `utilities`
 * counts every follower, at properties the caller can't see too, so a setup it allows also has no hidden properties.
 */
export const canArchive = setup => !setup.isArchived && setup.utilities === 0 && setup.pendingLinks === 0;